import { criarRepositorio } from './createRepository';

export const repositorioPasto = criarRepositorio('pasto');
export const repositorioAnimal = criarRepositorio('animal');
export const repositorioLote = criarRepositorio('lote');
export const repositorioAnimalLote = criarRepositorio('animal_lote');
export const repositorioPesagem = criarRepositorio('pesagem');
export const repositorioRotacaoPasto = criarRepositorio('rotacao_pasto');
export const repositorioMortalidade = criarRepositorio('mortalidade');
export const repositorioNatalidade = criarRepositorio('natalidade');
export const repositorioEventoManejo = criarRepositorio('evento_manejo');
export const repositorioMovimentacaoPecuaria = criarRepositorio('movimentacao_pecuaria');
export const repositorioSessaoPesagem = criarRepositorio('sessao_pesagem');
export const repositorioLinhaSessaoPesagem = criarRepositorio('linha_sessao_pesagem');
// TipoManejo não tem endpoint /sync/ (catálogo global, sem fazenda) — a
// página continua usando a API diretamente, sem repositório.
